export enum OTPStatus {
  Used = 1,
  Pending = 2,
  Canceled = 3
}
